import { development } from './development';
import { production } from './production';
import type { Environment } from './types';

export type { Environment, Features } from './types';

// Vite inlines MODE, so the build drops the environment it doesn't pick.
export const environment: Environment =
  import.meta.env.MODE === 'production' ? production : development;
